import { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  MenuItem,
  Select,
  Button,
  CardMedia,
  IconButton,
  Input,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditText from "../../components/editText";

const AddRewards = () => {
  const navigate = useNavigate();
  const [type, setType] = useState("default");
  const [category, setCategory] = useState("default");
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [legal1, setLegal1] = useState<string>("");
  const [legal2, setLegal2] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Add Rewards & Offers</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-rewards")}>
            Rewards & Offers Management
          </button>{" "}
          - Add Rewards & Offers
        </p>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">

            {/* Banner Image */}
            <div className="control_group w_100">
              <label htmlFor="reward_image">Upload Banner Image</label>
              <div className="gap_p">
                <div className="control_group w_33">
                  {image ? (
                    <div className="upload_image no_radius v2">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia
                            component="img"
                            image={image}
                            alt="Uploaded banner"
                          />
                        </figure>
                        <IconButton
                          aria-label="Remove uploaded image"
                          onClick={() => {
                            setImage("");
                            setFileName("");
                          }}
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    <label
                      className="upload_image no_radius v2"
                      htmlFor="reward_image"
                    >
                      <Input
                        sx={{ display: "none" }}
                        id="reward_image"
                        type="file"
                        inputProps={{ accept: "image/png,image/jpeg" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = (event.target as HTMLInputElement).files;
                          if (files && files[0].type.includes("image")) {
                            setFileName(files[0].name);
                            setImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt="placeholder"
                          />
                          <span className="upload_img_icon">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Upload"
                            />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Title */}
            <div className="control_group w_50">
              <label htmlFor="reward_title">Reward Title</label>
              <TextField
                id="reward_title"
                placeholder="Enter Reward Title"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Type */}
            <div className="control_group w_50">
              <div className="gap_p">
                <div className={`control_group ${type === "default" ? "w_100" : "w_50"}`}>
                  <label htmlFor="reward_type">Reward Type</label>
                  <Select
                    id="reward_type"
                    fullWidth
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <MenuItem disabled value="default">
                      Select Type
                    </MenuItem>
                    <MenuItem value="discount">Discount</MenuItem>
                    <MenuItem value="cashback">Cashback</MenuItem>
                  </Select>
                </div>

                {type === "discount" && (
                  <div className="control_group w_50">
                    <label htmlFor="discount_value">Discount Value (%)</label>
                    <TextField
                      id="discount_value"
                      type="number"
                      placeholder="Enter Discount Percentage"
                      fullWidth
                      hiddenLabel
                    />
                  </div>
                )}

                {type === "cashback" && (
                  <div className="control_group w_50">
                    <label htmlFor="cashback_value">Cashback Amount</label>
                    <TextField
                      id="cashback_value"
                      type="number"
                      placeholder="Enter Cashback Amount"
                      fullWidth
                      hiddenLabel
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Loyalty Points Required */}
            <div className="control_group w_33">
              <label htmlFor="loyalty_points">Loyalty Points Required</label>
              <TextField
                id="loyalty_points"
                type="number"
                placeholder="Enter Points"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Validity Period */}
            <div className="control_group w_33">
              <label htmlFor="valid_from">Valid Start Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="icon" />,
                  }}
                  slotProps={{
                    textField: {
                      id: 'valid_from',
                      placeholder: "Select Valid Start Date",
                      fullWidth: true,
                      hiddenLabel: true
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
            <div className="control_group w_33">
              <label htmlFor="valid_to">Valid End Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="icon" />,
                  }}
                  slotProps={{
                    textField: {
                      id: 'valid_to',
                      placeholder: "Select Valid End Date",
                      fullWidth: true,
                      hiddenLabel: true
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            {/* CTA Label */}
            <div className="control_group w_33">
              <label htmlFor="cta_label">CTA Label</label>
              <TextField
                id="cta_label"
                placeholder="e.g., Redeem Now"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Max Redemption */}
            <div className="control_group w_33">
              <label htmlFor="max_redemption">Max Redemption / Voucher Limit per user</label>
              <TextField
                id="max_redemption"
                type="number"
                placeholder="Enter Limit"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Assign to Category */}
            <div className="control_group w_33">
              <label htmlFor="category">Assign to Category</label>
              <Select
                id="category"
                fullWidth
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Category
                </MenuItem>
                <MenuItem value="books">Books</MenuItem>
                <MenuItem value="uniforms">Uniforms</MenuItem>
                <MenuItem value="stationary">Stationary</MenuItem>
              </Select>
            </div>

            {/* Description */}
            <div className="control_group w_100">
              <label htmlFor="reward_desc">Description</label>
              <EditText content={legal1} setContent={setLegal1} />
            </div>

            {/* Terms & Conditions */}
            <div className="control_group w_100">
              <label htmlFor="reward_terms">Terms & Conditions</label>
              <EditText content={legal2} setContent={setLegal2} />
            </div>
          </div>

          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-rewards")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddRewards;
